export const MIN_DRAWER_WIDTH = 360;
/** Matches the drawer's original `max-w-md` (28rem). */
export const DEFAULT_DRAWER_WIDTH = 448;
const MAX_VIEWPORT_SHARE = 0.7;
const STORAGE_KEY = 'projectAgentDrawer.width';

type WidthStorage = Pick<Storage, 'getItem' | 'setItem'>;

/** Bounds the side-drawer width to [360 px, 70 % of the viewport]; the minimum wins on tiny viewports. */
export function clampDrawerWidth(width: number, viewportWidth: number): number {
  const max = Math.floor(viewportWidth * MAX_VIEWPORT_SHARE);
  return Math.max(MIN_DRAWER_WIDTH, Math.min(width, max));
}

/** The persisted width, or `undefined` when missing, invalid, or the storage throws. */
export function readDrawerWidth(storage: WidthStorage): number | undefined {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (raw === null) return undefined;
    const parsed: unknown = JSON.parse(raw);
    return typeof parsed === 'number' && Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
  } catch {
    return undefined;
  }
}

export function writeDrawerWidth(storage: WidthStorage, width: number): void {
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(Math.round(width)));
  } catch {
    // Storage unavailable (private mode / quota) — the width stays in memory only.
  }
}

/** `localStorage`, or `undefined` where even reading the global throws (sandboxed iframes). */
export function browserLocalStorage(): WidthStorage | undefined {
  try {
    return localStorage;
  } catch {
    return undefined;
  }
}
